export const i = {
	'index_welcome': '欢迎光临。',
	'index_introduce': '-',
	'index_contact': '联系方式',
	'index_contact_phone': '电话',
	'index_artcleCategory': '文章分类',
	'index_all': '全部',
	'index_technology': '技术',
	'index_life': '生活',
	'index_photography': '摄影',
	'index_other': '其它'
}
